import Vue from 'vue';

export default {
	login(credentials) {
		return new Promise((resolve, reject) => {
			const body = {
				PKM_Nutzername: credentials.username,
				S_Passwort: credentials.password,
			};
			Vue.http.post(process.env.LOGIN_URL, body)
			.then((response) => {
				resolve(response.body);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	logout() {
	},
};



// WEBPACK FOOTER //
// ./src/api/auth.js